/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class QueryDBResponse {
  /**
  * Query ID. Can be used to call [Get Query Status](./get-query-status) and [Get Query Result](./get-query-result). 
  */
  'queryId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "queryId",
      "baseName": "queryId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return QueryDBResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

